import { useEffect, useRef, useState } from "react";
import AdvanceRightModal from "../../../components/Modal/AdvanceRightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { handleDropdownClose } from "../../../utils/utils";
import ContractCloseAdvanceFilterData from "./ContractCloseAdvanceFilterData";

// ✅ Real empty state for clearing
const EMPTY_ADVANCE_FILTER = [];

const ContractCloseAdvanceFilter = ({
  filterData,
  activeTab,
  onSetFilterData,
  onCallApiAgain,
  from = "Contract-To-Close"
}) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(
    localStorage.getItem("selectedSavefilterId") || ""
  );

  // ✅ UI-only empty row
  const initialEmptyState = [
    {
      id: Date.now(),
      condition: "AND",
      filters: [{ join: null, field: "", operator: "", value: "" }],
    },
  ];

  const [localFilterData, setLocalFilterData] = useState(initialEmptyState);

  /* ---------------- SYNC WITH PARENT (Important Fix) ---------------- */
  useEffect(() => {
    if (filterData?.length > 0) {
      setLocalFilterData(filterData);
    } else {
      setLocalFilterData(initialEmptyState);
    }
  }, [filterData]);

  /* ---------------- Close dropdown when clicking outside ---------------- */
  useEffect(() => {
    handleDropdownClose(dropdownRef, () => setIsSidebarOpen(false));
  }, []);

  /* ---------------- APPLY FILTER ---------------- */
  const handleFilter = () => {
    onSetFilterData(localFilterData);
    onCallApiAgain(localFilterData);
    localStorage.setItem("advanceFilterData", JSON.stringify(localFilterData));
    localStorage.setItem("filterData", JSON.stringify(localFilterData));
    setIsSidebarOpen(false);
  };

  /* ---------------- CLEAR ALL FILTERS ---------------- */
  const handleClearAll = () => {
    const empty = EMPTY_ADVANCE_FILTER;

    onSetFilterData(empty);
    onCallApiAgain(empty);
    setLocalFilterData(initialEmptyState);
    setSelectedSaveFilterId("");

    localStorage.removeItem("advanceFilterData");
    localStorage.removeItem("selectedSavefilterId");
    localStorage.removeItem("filterData");

    setIsSidebarOpen(false);
  };

  /* ---------------- CLEAR FROM SAVED FILTER ---------------- */
  const handleClearFromSavedFilter = () => {
    const empty = EMPTY_ADVANCE_FILTER;
    onSetFilterData(empty);
    onCallApiAgain(empty);
    setLocalFilterData(initialEmptyState);
    setSelectedSaveFilterId("");
  };

  /* ---------------- SELECT SAVED FILTER ---------------- */
  const handleSelectFilter = (value) => {
    const filters = value?.advance_filters || EMPTY_ADVANCE_FILTER;

    onSetFilterData(filters);
    onCallApiAgain(filters);
    setLocalFilterData(filters.length ? filters : initialEmptyState);

    localStorage.setItem("advanceFilterData", JSON.stringify(filters));
    localStorage.setItem("filterData", JSON.stringify(filters));
  };

  const saveSearchFilterData = {
    advance_filters: localFilterData,
  };

  const filterCount = localFilterData?.filter(group =>
    group?.filters?.some(f => f.field || f.operator || f.value)
  ).length || 0;

  return (
    <>
      <SavedFilterComponent
        from="Contract To close Save Filter"
        filterType="advance"
        count={filterCount}
        isSidebarOpen={isSidebarOpen}
        initialFilterData={EMPTY_ADVANCE_FILTER}
        selectedSavefilterId={selectedSavefilterId}
        saveSearchFilterData={saveSearchFilterData}
        onSetIsSidebarOpen={setIsSidebarOpen}
        onSetFilterData={handleClearFromSavedFilter}
        onCallApiAgain={onCallApiAgain}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
      />

      <AdvanceRightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Advance Filter"
        from={from}
        onFilter={handleFilter}
        onClose={() => setIsSidebarOpen(false)}
        onClearAll={handleClearAll}
      >
        <ContractCloseAdvanceFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={localFilterData}
          activeTab={activeTab}
          onSetFilterData={setLocalFilterData}
        />
      </AdvanceRightModal>
    </>
  );
};

export default ContractCloseAdvanceFilter;